module.exports = {"name":"Vyhľadávanie trénerov","icon":"<i class='material-icons'>people</i>","widget":[{"type":"coach-search-szts","head":["Meno","Priezvisko","Klubová príslušnosť STODIDO","Klubová príslušnosť Rock and Roll","Klubová príslušnosť Tanečný šport"],"cols":[["baseData.name.v"],["baseData.surName.v"],["coach.doBoogieWoogie.baseData.name.v"],["coach.doRockAndRoll.baseData.name.v"],["coach.doSportDance.baseData.name.v"]],"initData":{},"schemas":{"APIcoachsBaseData":"urn:mbry:schema:1:APIcoachsBaseData:v1"}}]}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/coach-search-szts/coach-search-szts.json
// module id = 316
// module chunks = 0